import { Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class MensajesService {

  constructor(
    private toastr : ToastrService
  ) { }

  private readonly commonCustomPartial: Partial<IndividualConfig> = {
    timeOut: 2000,
    positionClass: 'toast-custom-position',
    toastClass: 'ngx-toastr ngx-custom-toastr'
  };

  private readonly errorCustomPartial: Partial<IndividualConfig> = {
    ...this.commonCustomPartial,
    timeOut: 6000
  };

  public mensajeExito(mensaje :string, titulo? :string){
    this.toastr.success(mensaje, titulo, this.commonCustomPartial);
  }

  public mensajeExitoFijo(mensaje :string, titulo? :string){
    this.toastr.success(mensaje, titulo, { ... this.commonCustomPartial , timeOut : 0 , extendedTimeOut : 0});
  }

  public mensajeError(mensaje :string, titulo? :string){
    this.toastr.error(mensaje, titulo, this.errorCustomPartial);
  }

  public mensajeErrorHtml(mensaje :string, titulo? :string){
    this.toastr.error(mensaje, titulo, { ...this.errorCustomPartial, enableHtml: true });
  }

  public mensajeErrorFijo(mensaje :string, titulo? :string){
    this.toastr.error(mensaje, titulo, { ... this.commonCustomPartial , timeOut : 0 , extendedTimeOut : 0});
  }

  public mensajeInfo(mensaje :string, titulo? :string){
    this.toastr.info(mensaje, titulo, this.commonCustomPartial);
  }

  public mensajeInfoFijo(mensaje :string, titulo? :string){
    this.toastr.info(mensaje, titulo, { ... this.commonCustomPartial , timeOut : 0 , extendedTimeOut : 0});
  }
}
